/**
 *
 * Module to encapsulate basic event trigger calls, like ga/gtm pixel tracking, etc.
 *
 *
 */

var docCookies = require('doc-cookies');

/**
 *
 * @return {jQuery|HTMLElement}
 */
function getDefaultTarget() {
    return $(window.document);
}


module.exports = {
    /**
     * Predefined 'action' event
     *
     * @param {{}} data - event data
     */
    fireAction: function (data) {
        return getDefaultTarget().trigger('action', data);
    },

    /**
     * Predefined 'pageView' event
     *
     * @param {{}} data - event data
     */
    firePageView: function (data) {
        return getDefaultTarget().trigger('pageView', data);
    },

    /**
     * Subscribe custom event (not predefined event type like action or pageView)
     * @param eventName
     * @param listener
     * @param $target
     */
    subscribeCustomEvent: function (eventName, listener, $target) {
        return ($target || getDefaultTarget()).on(eventName, listener);
    },

    /**
     * Unsubscribe custom event (not predefined event type like action or pageView)
     * @param eventName
     * @param listener
     * @param $target
     */
    unsubscribeCustomEvent: function (eventName, listener, $target) {
        return ($target || getDefaultTarget()).off(eventName, listener);
    },

    /**
     * Fire custom event (not predefined one like action or pageView)
     * @param eventName
     * @param data
     * @param $target
     */
    fireCustomEvent: function (eventName, data, $target) {
        if( eventName === 'fire_impression_tracking' &&
           (docCookies.getItem('disableallthirdparty') || docCookies.getItem('disableallads'))) {
            return $target || getDefaultTarget();
        }
        return ($target || getDefaultTarget()).trigger(eventName, data);
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/utils/event-toolbox/event-toolbox.js
// module id = 1
// module chunks = 36